import { stepperStore } from './modules/stepper'
const systemStore = {
  state: {
    ...stepperStore.state,
    carrierName: '',
    configUrls: null,
    isLoading: false,
    language: null,
    availableLanguages: [],
    langSwitcher: null,
    sessionId: null,
    flow: null,
    logoUrlRedirect: null,
    elegibility: {
      flowDiscount: false,
      documentsFiltered: Object
    },
    summaryBehavior: {
      state: '',
      continueButton: Boolean,
      showSummary: Boolean,
    },
    showHeader: true,
    appName: null,
    pathList: [window.location.pathname],
    eGTMCode: '',
    eGACode: '',
    widgetApps: null,
    generalSetting: null,
    timeoutSpinner: null,
    searchData: {},
    posId: [],
    apiVersion: null,
    bookingPrices: {
      purchasePrice: null,
      summaryPrice: null
    },
    ecsSubscriptionActivated: null,
    countrySetting: {},
    currencyChanged: 0,
    showCurrencySelector: false,
    selectedDatesToExchange: [],
    selectedFlightsToExchange: [],
    exchangeOriginalFlights: [],
    exchangeNewPriceDetail: null,
    GASearchFlight: {},
    GAItemView: {
      goingFlight: null,
      returnFlight: null
    },
    GAExtraServices: {
      items: [],
      seatMapItems: [],
      selectedSeats: null
    },
    extraServicesByPassengerSegment: {},
    flowWebCkInFromMMB: false,
    fixed_pos: false,
    extraServicesMovementChecker: {},
    deviceType: null,
    commonInformation: {},
    turnstile: {
      siteKey: true,
      token: ''
    }
  },
  getters: {
    ...stepperStore.getters,
    getCarrier: state => {
      return state.carrierName
    },
    getApiVersion: state => {
      return state.apiVersion
    },
    getConfigUrls: state => {
      return state.configUrls
    },
    isLoading: state => {
      return state.isLoading
    },
    getLanguage: state => {
      return state.language
    },
    getAvailableLanguages: state => {
      return state.availableLanguages
    },
    getSessionId: state => {
      return state.sessionId
    },
    getFlow: state => {
      return state.flow
    },
    getShowHeader: state => {
      return state.showHeader
    },
    getAppName: state => {
      return state.appName
    },
    getPathList: state => {
      return state.pathList
    },
    getGTMCode: state => {
      return state.eGTMCode
    },
    getGACode: state => {
      return state.eGACode
    },
    getLogoUrlRedirect: state => {
      return state.logoUrlRedirect
    },
    getWidgetApps: state => {
      return state.widgetApps
    },
    getGeneralSettings: state => {
      return state.generalSetting
    },
    getSearchData: state => {
      return state.searchData
    },
    getElegibility: state => {
      return state.elegibility
    },
    getBookingPrices: state => {
      return state.bookingPrices
    },
    getLangSwitcher: state => {
      return state.langSwitcher
    },
    getPosId: state => {
      return state.posId
    },
    areBookingPricesDifferent: state => {
      if (state.bookingPrices.summaryPrice && state.bookingPrices.purchasePrice) {
        return state.bookingPrices.summaryPrice.toFixed(2) !== state.bookingPrices.purchasePrice.toFixed(2)
      }
      return false
    },
    getCurrencyChanged: state => {
      return state.currencyChanged
    },
    getCountrySetting: state => {
      return state.countrySetting
    },
    getShowCurrencySelector: state => {
      return state.showCurrencySelector
    },
    getEcsSubscriptionActivated: state => state.ecsSubscriptionActivated,
    getSelectedDatesToExchange: state => state.selectedDatesToExchange,
    getSelectedFlightsToExchange: state => state.selectedFlightsToExchange,
    getExchangeOriginalFlights: state => state.exchangeOriginalFlights,
    getExchangeNewPriceDetail: state => state.exchangeNewPriceDetail,
    getNextSpa: state => {
      if (state.flow) {
        const actualIndex = state.flow.findIndex(x => state.pathList.includes(x.url))
        return state.flow[actualIndex + 1].url
      }
    },
    getGAItemView: state => state.GAItemView,
    getGAExtraServices: state => state.GAExtraServices,
    getGASearchFlight: state => state.GASearchFlight,
    getExtraServicesByPassengerSegment: state => {
      return state.extraServicesByPassengerSegment
    },
    getflowWebCkInFromMMB (state) {
      return state.flowWebCkInFromMMB
    },
    getFixed_Pos (state) {
      return state.fixed_pos
    },
    getExtraServicesMovementChecker (state) {
      return state.extraServicesMovementChecker
    },
    getCommonInformation: state => state.commonInformation,
    getGA4AppNamePath: (state) => (nextSpa) => {
      //KE-4477 para manage y CkIn, agrega al path el nombre de la App
      nextSpa = nextSpa.endsWith('/') ? nextSpa : nextSpa + '/'
      const urlsAddAppName = ['/extraservices/', '/purchase/', '/endflow/', '/seats/']
      const isSpaToAddAppName = urlsAddAppName.includes(nextSpa) 

      const hasEnabledGA4Paths = state.configUrls.hasOwnProperty('enabledGA4Paths')
      if (state.appName !== "ecommerce" && isSpaToAddAppName && hasEnabledGA4Paths && state.configUrls.enabledGA4Paths) {
        return `${state.appName}`
      }
      return ''
    },
    getTurnstile: state => state.turnstile,
  },
  mutations: {
    ...stepperStore.mutations,
    setConfigUrls (state, config) {
      state.configUrls = config
    },
    setApiVersion (state, version) {
      state.apiVersion = 'v' + version
    },
    setCarrier (state, carrierName) {
      state.carrierName = carrierName.toLowerCase()
    },
    setSearchData (state, searchData) {
      state.searchData = searchData
    },
    setLoading (state, flag) {
      if (flag) {
        document.querySelector('#initial-spinner').classList.remove("d-none")
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties,vue/no-async-in-computed-properties
        state.timeoutSpinner = setTimeout(() => {
          state.isLoading = false
          document.querySelector('#initial-spinner').classList.add('d-none')
        }, 30 * 1000)
      } else {
        document.querySelector('#initial-spinner').classList.add('d-none')
        clearTimeout(state.timeoutSpinner)
      }
      state.isLoading = flag
    },
    setLanguage (state, language) {
      state.language = language
    },
    setSessionId (state, sessionId) {
      state.sessionId = sessionId
    },
    summaryBehaviorHandler(state, behavior) {
      if(behavior.state == 'absolute') {
        state.summaryBehavior = behavior
        return
      }

      state.summaryBehavior.showSummary = !state.summaryBehavior.showSummary;
      state.summaryBehavior.continueButton = !state.summaryBehavior.continueButton;
    },
    setFlow (state, flow) {
      state.flow = flow
    },
    setShowHeader (state, showHeader) {
      state.showHeader = showHeader
    },
    setAppName (state, appName) {
      state.appName = appName
    },
    setPathList (state, pathList) {
      state.pathList = pathList
    },
    addAvailableLanguages (state, lang) {
      state.availableLanguages.push(lang)
    },
    clearAvailableLanguages (state) {
      state.availableLanguages = []
    },
    setGTMCode (state, eGTMCode) {
      state.eGTMCode = eGTMCode
    },
    setGACode (state, eGACode) {
      state.eGACode = eGACode
    },
    setLogoUrlRedirect (state, logoUrlRedirect) {
      state.logoUrlRedirect = logoUrlRedirect !== '' ? logoUrlRedirect : null
    },
    setWidgetApps (state, widgetApps) {
      state.widgetApps = widgetApps
    },
    setGeneralSettings (state, generalSettings) {
      state.generalSetting = generalSettings
    },
    setElegibility (state, elegibility) {
      state.elegibility = elegibility
    },
    setBookingPrices (state, bookingPrices) {
      Object.keys(bookingPrices).forEach(key => {
        state.bookingPrices[key] = bookingPrices[key]
      })
    },
    setEcsSubscriptionActivated (state, ecsSubscriptionActivated) {
      state.ecsSubscriptionActivated = ecsSubscriptionActivated
    },
    setLangSwitcher(state, languages) {
      if (!languages || typeof languages !== 'object') {
        console.error('not exist lang_switcher key in jjecommerce')
        languages = {
          "current": {
            "flag": true
          },
          "languages": {
            "flag": true,
            "items": [
              {
                "lang": "en"
              }
            ]
          }
        }
      }
      state.langSwitcher = languages
    },
    setPosId (state, posId) {
      state.posId = posId
    },
    setCurrencyChanged (state, config) {
      state.currencyChanged = config
    },
    setCountrySetting (state, config) {
      state.countrySetting = config
    },
    setShowCurrencySelector (state, config) {
      state.showCurrencySelector = config
    },
    setSelectedDatesToExchange (state, datesToExchange) {
      state.selectedDatesToExchange = datesToExchange
    },
    setSelectedFlightsToExchange (state, flightsToExchange) {
      state.selectedFlightsToExchange = flightsToExchange
    },
    setExchangeOriginalFlights (state, originalFlighst) {
      state.exchangeOriginalFlights = originalFlighst
    },
    setExchangeNewPriceDetail (state, exchangeNewPriceDetail) {
      state.exchangeNewPriceDetail = exchangeNewPriceDetail
    },
    setGAItemView (state, data) {
      const { info, ...rest } = data
      state.GAItemView[info] = rest
    },
    setGASearchFlight(state, data) {
      state.GASearchFlight = data
    },
    clearGASearchFlight(state) {
      state.GASearchFlight = {}
    },
    clearGAItemView (state) {
      state.GAItemView = {
        goingFlight: null,
        returnFlight: null
      }
    },
    setGAExtraServices (state, data) {
      state.GAExtraServices = data
    },
    clearGAExtraServices (state) {
      state.GAExtraServices = {
        items: [],
        seatMapItems: [],
        selectedSeats: null
      }
    },
    setExtraServicesByPassengerSegment (state, value) {
      state.extraServicesByPassengerSegment = value
    },
    setflowWebCkInFromMMB (state, data) {
      state.flowWebCkInFromMMB = data
    },
    setFixed_Pos (state, data) {
      state.fixed_pos = data
    },
    setExtraServicesMovementChecker (state, data) {
      state.extraServicesMovementChecker = data
    },
    setDeviceType (state, deviceType) {
      state.deviceType = deviceType
    },
    addToCommonInformation (state, commonInformation) {
      Object.keys(commonInformation).forEach((key) => {
        state.commonInformation[key] = commonInformation[key]
      })
    },
    setTurnstile (state, turnstile) {
      state.turnstile = turnstile
    }
  },
  actions: {
    ...stepperStore.actions,
    setSession ({ commit }, response) {
      commit('setSessionId', response.session_key)
      commit('setFlow', response.flow)
    },
    expireSession ({ commit }) {
      commit('setSessionId', null)
    },
    goNextSpa ({ state, getters }) {
      const nextSpa = getters.getNextSpa
      this.commit('setPathList', [nextSpa])
      this.commit('setLoading', true)

      window.top.location.href = `${window.location.protocol}//${window.location.hostname}${nextSpa}${getters.getGA4AppNamePath(nextSpa)}`
    },
    goOutsideIframe ({ state, getters }, altParams={}) {
      const nextSpa = altParams.path ? `/${altParams.path}/` : getters.getNextSpa
      const params = {
        id_session: state.sessionId,
        lang: state.language,
        carrier: state.carrierName,
        ...altParams.query
      }
      const searchParams = new URLSearchParams(params)
      this.commit('setLoading', true)
      window.top.location.href = `${window.location.protocol}//${window.location.hostname}${nextSpa}?${searchParams.toString()}`
    },
    goBackSpa ({ state, getters }) {
      /**
       *  urlsNoAllowedByBack remove not allowed urls  to back from session flow
       *  example: /travellerdetails (temporary) or booking
       *
       *  About this upgrade:
       *    remove traveller details and booking urls from session flow for back button
       *    then find our find index, if it's the first (index 0) we raise an exception
       *    else success and location to go back
       */
      const urlsNoAllowedByBack = ['/searchflight/', '/travellerdetails/', '/booking/']
      let allowUrlsToBack = state.flow.filter(x => !urlsNoAllowedByBack.includes(x.url))
      let actualIndex = -1
      let arrayToBack = null
      if (urlsNoAllowedByBack.find(x => state.pathList.includes(x))){
        actualIndex = state.flow.findIndex(x => state.pathList.includes(x.url))
        arrayToBack = state.flow
      } else {
        actualIndex = allowUrlsToBack.findIndex(x => state.pathList.includes(x.url))
        arrayToBack = allowUrlsToBack
      }
      if (actualIndex <= 0) {
        throw new Error("back does not exist.")
      }
      let backSpa = arrayToBack[actualIndex - 1].url
      this.commit('setLoading', true)
      this.commit('setPathList', [backSpa])

      window.top.location.href = `${window.location.protocol}//${window.location.hostname}${backSpa}${getters.getGA4AppNamePath(backSpa)}`
    },
    goFirstSpa ({ state, getters }) {
      let nextSpa = state.flow[0].url
      this.commit('setPathList', [nextSpa])
      this.commit('setLoading', true)

      window.top.location.href = `${window.location.protocol}//${window.location.hostname}${nextSpa}${getters.getGA4AppNamePath(nextSpa)}` 
    },
    goToSpa ({ state, getters }, payload) {
      // agrego para poder recibir una object o un string (version original)
      // en caso de ser un object, de tener {nextSPA , customURL}
      let newPath = ''
      let customURL = ''
      const isCustomURL = (typeof payload === 'object')
      if (isCustomURL) {
        // nueva version usada en Purchase KEMMB-937
        newPath = payload.nextSPA
        customURL = payload.customURL
      } else {
        newPath = payload
      }
      //-----------------------------------------
      let nextSpa = state.flow[state.flow.findIndex(x => x.url == `/${newPath}/`)].url
      this.commit('setPathList', [nextSpa])
      this.commit('setLoading', true)
 
      if (isCustomURL) {
        window.top.location.href = `${window.location.protocol}//${window.location.hostname}${nextSpa}${customURL}`
      } else {
        window.top.location.href = `${window.location.protocol}//${window.location.hostname}${nextSpa}${getters.getGA4AppNamePath(nextSpa)}`
      }
    },
    goToSpaQuery ({ state }, newPath) {
      let nextSpa = state.flow[state.flow.findIndex(x => x.url === `/${newPath['path']}/`)].url
      this.commit('setPathList', [nextSpa])
      this.commit('setLoading', true)
      if (newPath['query']) {
        nextSpa = nextSpa + '?' + newPath['query']
      }
      window.top.location.href = `${window.location.protocol}//${window.location.hostname}${nextSpa}`
    }
  }
}

export { systemStore }
